'use client';

import { Button } from '@ui/components/common/button';

interface CategoryDrawerTriggerProps {
  seeMoreText: string;
  onOpenDrawer: () => void;
}

/**
 * Client component for the "See More" button that opens the category drawer on mobile
 * Isolated to keep the main CategorySection as a server component
 */
export function CategoryDrawerTrigger({ seeMoreText, onOpenDrawer }: CategoryDrawerTriggerProps) {
  return <Button variant="link" label={seeMoreText} onClick={onOpenDrawer} />;
}
